import * as React from "react";
import Layout from "../layout/layout";
import HeroBanner from "../components/home/hero-banner";
import BrowseLocation from "../components/home/browse-location";
import LatestNews from "../components/home/latest-news";
export default class Home extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Layout, { route: this.props.route },
            React.createElement(HeroBanner, { id: "2", overrideLink: "/Products/Search?madeInAlberta=true" }),
            React.createElement(LatestNews, { products: this.props.products.slice(0, 4) }),
            React.createElement(BrowseLocation, { products: this.props.products.slice(4) })));
    }
}
//# sourceMappingURL=home.js.map